import { Box } from "@mui/material";
import { styled } from "@mui/material";

export const ContactContainer = styled(Box)<{}>(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  margin: "0 auto",
  marginBottom: "5rem",
  boxSizing: "border-box",
  padding: "0 1rem",
  width: "100%",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0 1.5rem",
    gap: "2rem",
    marginBottom: "7.5rem",
  },

  [theme.breakpoints.up("lg")]: {
    padding: "0 2rem",
  },
}));

export const AddressContainer = styled(Box)<{}>(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    width: "35%",
  },
}));

export const MapContainer = styled("div")(({ theme }) => ({
  overflow: "hidden",
  borderRadius: "24px",
  height: "fit-content",

  img: {
    width: "358px",
    height: "280px",
    objectFit: "cover",
    borderRadius: "8px",
  },

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    width: "65%",

    img: {
      width: "100%",
      height: "100%",
    },
  },
}));
